import Styled from './Styled';
import createStyledFn from './createStyled';
export var createStyled = createStyledFn;
export default Styled;